import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = credential => {

        if (typeof credential !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        return {
            id:     credential.id,
            alias:  credential.alias,
            vendor: {
                selected: vendorCodes.oracle,
                values:   {
                    service:     credential.service.id,
                    account:     credential.account.id,
                    accountName: credential.account.name,
                    userOcid:    credential.user_ocid,
                    tenancyOcid: credential.tenancy_ocid,
                    privateKey:  credential.private_key,
                    fingerprint: credential.fingerprint,
                    passphrase:  credential.passphrase,
                    slug:        credential.service.slug
                }
            }
        };
    },
    mapFields = {
        userOcid:    'user_ocid',
        tenancyOcid: 'tenancy_ocid',
        privateKey:  'private_key',
        passphrase:  'passphrase',
        account:     'account',
        fingerprint: 'fingerprint',
        service:     'service'
    },
    mapParametersToSave = {
        userOcid:    'user_ocid',
        tenancyOcid: 'tenancy_ocid',
        privateKey:  'private_key',
        passphrase:  'passphrase',
        account:     'account',
        fingerprint: 'fingerprint',
        service:     'service'
    },
    transformEntitiesToSaveFn = credential => Object.keys(credential.vendor)
        .reduce((ret, key) => ({
            ...ret,
            [mapParametersToSave[key]]: credential.vendor[key]
        }), {
            alias:       credential.alias,
            userOcid:    credential.user_ocid,
            tenancyOcid: credential.tenancy_ocid,
            privateKey:  credential.private_key,
            passphrase:  credential.passphrase,
            account:     credential.account,
            fingerprint: credential.fingerprint,
            service:     credential.service
        });

const exports = storeModuleFactory({
    name:             'oracleCredentials',
    endpoint:         endpoints.securityCredentials.oracle.endpoint,
    instanceEndpoint: endpoints.securityCredentials.oracle.instanceEndpoint,
    callbackActions:  [{
        method: 'create',
        action: invalidateSecurityCredentials
    },{
        method: 'update',
        action: invalidateSecurityCredentials
    },{
        method: 'delete',
        action: invalidateSecurityCredentials
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/oracleCredentials.js